/* ESTASY — Collection filters: AJAX facet updates + mobile drawer toggle. */
(function () {
  'use strict';

  const form = document.querySelector('[data-filters-form]');
  if (!form) return;

  let debounce;

  function applyFilters() {
    const params = new URLSearchParams(new FormData(form));
    const url = `${window.location.pathname}?${params.toString()}`;
    fetchResults(url);
    history.pushState({ url }, '', url);
  }

  async function fetchResults(url) {
    const grid = document.querySelector('[data-product-grid]');
    const toolbar = document.querySelector('[data-collection-count]');
    if (grid) grid.setAttribute('aria-busy', 'true');
    try {
      const res = await fetch(url);
      const text = await res.text();
      const doc = new DOMParser().parseFromString(text, 'text/html');
      const newGrid = doc.querySelector('[data-product-grid]');
      const newCount = doc.querySelector('[data-collection-count]');
      const newActive = doc.querySelector('[data-active-facets]');
      if (newGrid && grid) grid.innerHTML = newGrid.innerHTML;
      if (newCount && toolbar) toolbar.innerHTML = newCount.innerHTML;
      const active = document.querySelector('[data-active-facets]');
      if (newActive && active) active.innerHTML = newActive.innerHTML;
      window.scrollTo({ top: form.getBoundingClientRect().top + window.scrollY - 120, behavior: 'smooth' });
    } catch (e) {
      console.error('Filter error', e);
    } finally {
      if (grid) grid.removeAttribute('aria-busy');
    }
  }

  form.addEventListener('input', (e) => {
    if (e.target.matches('select')) return applyFilters();
    clearTimeout(debounce);
    debounce = setTimeout(applyFilters, 450);
  });
  form.addEventListener('change', (e) => {
    if (e.target.matches('input[type="checkbox"], input[type="radio"]')) applyFilters();
  });

  // Clear single active facet
  document.addEventListener('click', (e) => {
    const clear = e.target.closest('[data-remove-facet]');
    if (clear) { e.preventDefault(); fetchResults(clear.getAttribute('href')); history.pushState({}, '', clear.getAttribute('href')); }
  });

  // Mobile drawer toggle for facets
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-facets-toggle]')) document.querySelector('.facets')?.classList.add('is-open');
    if (e.target.closest('[data-facets-close]')) document.querySelector('.facets')?.classList.remove('is-open');
  });

  window.addEventListener('popstate', (e) => {
    if (e.state && e.state.url) fetchResults(e.state.url);
  });
})();
